import pubkey from '@/services/pubkey';
var openpgp = require('openpgp');

openpgp.config.show_version = false;
openpgp.config.show_comment = false;
openpgp.initWorker({ path: 'js/openpgp/openpgp.worker.min.js' });

export async function _encrypt(plainText: string) {
  var publicKeys = (await openpgp.key.readArmored(pubkey.get())).keys;
  const options = {
    message: openpgp.message.fromText(plainText),
    publicKeys: publicKeys,
  };
  var result = await openpgp.encrypt(options).then((ciphertext: any) => {
    var encrypted = ciphertext.data;
    return encrypted;
  });

  return result;
}
